import { evaluateSavageAttacker, hasSavageAttacker } from './savageAttacker';
import { evaluateOverwhelmingStrike, hasIrresistibleOffense } from './irresistibleOffense';
import { evaluateGiantAncestry, hasGiantAncestryOnHit } from '../species/giantAncestry';
import { evaluateConjureMinorElementals, evaluateTrueStrike } from '../spellHits';

const knowsSpell = spellId => character => (character?.spells || []).some(spell => spell?.spellId === spellId);

// Feat hit hooks. Unlike class adapters they apply when the character has the feat, at any class level.
const featAdapters = Object.freeze([
  Object.freeze({ id: 'feat:savage-attacker', appliesTo: hasSavageAttacker, evaluateOnHit: evaluateSavageAttacker }),
  Object.freeze({ id: 'feat:boon-of-irresistible-offense', appliesTo: hasIrresistibleOffense, evaluateOnHit: evaluateOverwhelmingStrike }),
  // Species hit hooks share this list: they apply by species, at any class level.
  Object.freeze({ id: 'species:giant-ancestry', appliesTo: hasGiantAncestryOnHit, evaluateOnHit: evaluateGiantAncestry }),
  // Spells that add to hits apply to those who know them; the effect decides when.
  Object.freeze({ id: 'spell:conjure-minor-elementals', appliesTo: knowsSpell('conjure-minor-elementals'), evaluateOnHit: (context, queries) => evaluateConjureMinorElementals({ context, queries }) }),
  Object.freeze({ id: 'spell:true-strike', appliesTo: knowsSpell('true-strike'), evaluateOnHit: (context, queries) => evaluateTrueStrike({ context, queries }) }),
]);

export default featAdapters;
